import { render, staticRenderFns } from "./ShipmentTransferView.vue?vue&type=template&id=a71a7afa"
import script from "./ShipmentTransferView.vue?vue&type=script&lang=js"
export * from "./ShipmentTransferView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports